<div *ngIf="isPortalSelected && isAIChatEnabled && !isRaspberryAI">
  <div
    class="righticons-bar"
    (click)="openChatbot()"
  >
    <img
      src="{{ cdnEndPoint }}/shared/images/SVG/AI_Chat_Red.svg"
      class="setimg" 
      alt="Raspberry"
    />
  </div>
</div>


<!-- <div *ngIf="isPortalSelected && isAIChatEnabled">
  <div class="floating-chat-button" (click)="openChatbotModal()">
    <img src="{{ cdnEndPoint }}/shared/images/SVG/Raspberry_White_AI.svg" class="chat-icon" />
    <span class="chat-text">    Raspberry AI
    </span>
  </div>
</div> -->

<!-- Modal Content -->
<!-- <div class="floating-chatbox" *ngIf="isChatbotOpen" [ngClass]="{ 'maximized': isMaximized }">
  <div class="wc-chatview-panel" style="font-size: 15px">
    <div class="wc-header">
      <div class="banner-left">
        <img src="{{ cdnEndPoint }}/shared/images/SVG/Raspberry_White_AI.svg" />
        <span class="banner-text">RASPberry AI</span>
      </div>

      <div class="chat-controls">
        <a class="icon-resize" (click)="toggleSize()"></a>
        <a class="icon-minimize" (click)="minimizeChatbot()"></a>
        <a class="icon-close" (click)="closeChatbot()"></a>
      </div>
    </div>

    <div id="webchat" style="height: 100%"></div>
  </div>
</div> -->
<div
  #chatbox
  class="floating-chatbox"
  *ngIf="isChatbotOpen"
  [ngClass]="{ 'maximized': isMaximized, 'minimized': isMinimized }"
  [ngStyle]="isRaspberryAI?{'position': 'relative','width' : '100%' } : {}"
>

<div class="resizer" (mousedown)="onResizeStart($event)"></div>


  <div class="wc-header" *ngIf="!isRaspberryAI">
      <div class="banner-left">
        <span class="banner-text">RASPberry AI</span>
      </div>

      <div class="chat-controls">
        <a class="icon-edit-app" title="Start a New Conversation"  (click)="openNewChatbotModal()"><img src="{{cdnEndPoint}}/triport/icons/edit-app.svg"></a>
        <a class="icon-resize" (click)="toggleSize()">{{ isMaximized ? '⤡' : '⤢' }}</a>
        <a class="icon-minimize" (click)="minimizeChatbot()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="11" width="14" height="2" fill="white"/>
        </svg></a>
        <a class="icon-close" (click)="closeChatbot()"></a>

      </div>
    </div>

    <div
      class="webchat-wrapper"
      [class.rai-waiting]="isWaitingForResponse"
      [class.rai-landing-mode]="!hasStartedConversation"
    >
      <div class="rai-landing-title" *ngIf="!hasStartedConversation">
        Hi, how can I help you?
      </div>

      <div class="raspberry-ai" id="webchat"></div>

      <div class="rai-suggested-list" *ngIf="!hasStartedConversation">
        <button
          type="button"
          *ngFor="let prompt of suggestedPrompts"
          class="rai-suggested-card"
          (click)="sendSuggestedPrompt(prompt)"
        >
          {{ prompt }}
        </button>
      </div>

      <medpt-citation-popover
        *ngIf="showCitationPopover && citationPopoverData"
        [citation]="citationPopoverData"
        [positionX]="citationPopoverX"
        [positionY]="citationPopoverY"
        (chunkSelected)="onCitationChunkSelected($event)"
        (dismissed)="onCitationPopoverDismissed()"
      ></medpt-citation-popover>
      <div class="rai-status-indicator" *ngIf="statusMessage">
        <div class="rai-status-steps">
          <ng-container *ngFor="let stage of ['ANALYZING', 'SEARCHING', 'SYNTHESIZING', 'VALIDATING']; let i = index">
            <div
              class="rai-step"
              [class.active]="['ANALYZING', 'SEARCHING', 'SYNTHESIZING', 'VALIDATING'].indexOf(statusStage) >= i"
              [class.done]="['ANALYZING', 'SEARCHING', 'SYNTHESIZING', 'VALIDATING'].indexOf(statusStage) > i"
            >
              <span class="rai-step-icon">{{ i + 1 }}</span>
              <span class="rai-step-label">
                {{ i === 0 ? 'Analyze' : i === 1 ? 'Search' : i === 2 ? 'Prepare' : 'Validate' }}
              </span>
            </div>
            <div
              class="rai-step-line"
              *ngIf="i < 3"
              [class.done]="['ANALYZING', 'SEARCHING', 'SYNTHESIZING', 'VALIDATING'].indexOf(statusStage) > i"
            ></div>
          </ng-container>
        </div>
        <div class="rai-status-text">{{ statusMessage }}</div>
      </div>
    </div>
  
</div>

<!-- Minimized Chatbox -->
<div *ngIf="isMinimized" class="minimized-chatbox">
  <div class="banner-left">
    <img src="{{ cdnEndPoint }}/shared/images/SVG/Raspberry_White_AI.svg" class="chat-icon" />
    <span class="banner-text">RASPberry AI</span>
  </div>
  <div class="chat-controls">
    <a class="icon-restore" (click)="restoreChatbot()">⤡</a>
    <a class="icon-close" (click)="closeChatbot()"></a>
  </div>
</div>
